<template>
  <div class="flex justify-center items-center md:mt-16">
    <form
      class="w-full max-w-xl p-6 md:p-16 md:shadow-xl md:border dark:border-gray-700 md:rounded md:bg-white dark:bg-gray-800 transition-colors duration-200"
      @submit.prevent="register()"
    >
      <h2 class="font-bold text-2xl text-gray-900 dark:text-gray-100 mb-10">
        Register a new account
      </h2>
      <div class="rounded-md shadow-sm md:px-2">
        <div>
          <input
            v-model="email"
            aria-label="Email address"
            name="email"
            type="email"
            required
            class="form-input rounded-b-none"
            placeholder="Email address"
          />
        </div>
        <div class="-mt-px">
          <input
            v-model="password"
            aria-label="Password"
            name="password"
            type="password"
            required
            class="form-input rounded-none"
            placeholder="Password"
          />
        </div>
        <div class="-mt-px">
          <input
            v-model="repeat"
            aria-label="Repeat password"
            name="repeat"
            type="password"
            required
            class="form-input rounded-t-none"
            placeholder="Repeat password"
          />
        </div>
      </div>

      <div class="md:flex md:justify-center mt-6">
        <button
          type="submit"
          class="btn w-full my-1 md:w-1/2 md:mx-1"
          :disabled="!email || !password || password !== repeat"
        >
          Register
        </button>
      </div>
      <social-logins />
    </form>
  </div>
</template>

<script>
import SocialLogins from "../components/SocialLogins.vue";
import { firebaseAuth } from "@/services/firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";

export default {
  components: {
    SocialLogins,
  },
  data() {
    return {
      email: "",
      password: "",
      repeat: "",
    };
  },
  methods: {
    async register() {
      try {
        await createUserWithEmailAndPassword(
          firebaseAuth,
          this.email,
          this.password,
        );
        this.$router.push({ name: "login" });
      } catch (error) {
        alert(error.message);
      }
    },
  },
};
</script>
